<template>
  <div>
    <h2>{{ $t('store.forwardingToStore') }} </h2>
    <p>{{ $t('store.forwardingToStoreFailed') }} </p>
    <v-container fluid >
    <v-row>
      <v-col>
        <GooglePlayLink />
      </v-col>
    </v-row>
      <v-row>
        <v-col>
          <IosStoreLink />
        </v-col>
      </v-row>
    </v-container>
  </div>

</template>
<script>
import {
  IOS_STORE_STORY_CITY_URL,
  GOOGLE_PLAY_STORY_CITY_URL,
  DESKTOP_DOWNLOAD_STORY_CITY_URL
} from  "@/const"
import GooglePlayLink from "@/components/GooglePlayLink"
import IosStoreLink from "@/components/IosStoreLink"
export default {
  components: {
    GooglePlayLink,
    IosStoreLink,
  },
  mounted() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      window.location.replace(GOOGLE_PLAY_STORY_CITY_URL);
    }

    if (/android/i.test(userAgent)) {
      window.location.replace(GOOGLE_PLAY_STORY_CITY_URL);
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.replace(IOS_STORE_STORY_CITY_URL);
    }

    window.location.replace(DESKTOP_DOWNLOAD_STORY_CITY_URL);
  },
};
</script>